import { Icon, Tooltip } from '@dixa/lib-shared-habla';

import styles from './nodeLockIcon.module.scss';

export function NodeLockIconWithTooltip({
  label,
}: {
  label: string;
}): JSX.Element {
  return (
    <Tooltip content={label}>
      <span className={styles.nodeLockIcon}>
        <Icon name="lock" />
      </span>
    </Tooltip>
  );
}
